// This file must be present so auto.require.config.js will find and pre-require this module
define('model/find.first.query.model',['require','exports','module','fukit'],function(require, exports, module) {
  var FuKit = require('fukit');

  module.exports = FuKit.FindFirstQueryModel;
});

